import arrayReduce from './arrayReduce';

export default function applyMediaRulesInOrder(order) {
  return arrayReduce(order, function (mediaRules, query) {
    mediaRules[query] = '';
    return mediaRules;
  }, {});
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/fela-utils/es/applyMediaRulesInOrder.js
// module id = 846
// module chunks = 0